import { clsx } from 'clsx'
import { type FC, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'

import { useGetExperiment } from '../../../experiments/hooks'
import { EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS } from '../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../experiments/model/EXPERIMENT_VARIATION'
import { useRemovePacksizesExperimentShouldHideVariants } from '../../../experiments/remove-variants-for-expa-experiment/useRemoveVariantsExperimentShouldHideVariantsForExpa'
import { useHideAddToCart } from '../ProductBuyBox/useHideAddToCart'
import { useProductPageContext } from '../productPageContext'

import { ProductPageAttributeSelectionGroupRenderer } from './ProductPageAttributeSelectionGroupRenderer'
import { ProductPageAttributeGroupDivider } from './ProductPageAttributeSelectionGroupRenderer/ProductPageAttributeGroupDivider'

export const ProductPageAttributesSelection: FC = () => {
  const hideAddToCart = useHideAddToCart()
  const { attributeSelectionControls } = useProductPageContext()
  const { isSingleRenderGroup, renderGroups } = attributeSelectionControls

  const pdpDeliveryOptions = useGetExperiment(
    EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS,
  )

  const pdpDeliveryOptionsEnabled =
    pdpDeliveryOptions.isEnabled &&
    (pdpDeliveryOptions.variant === EXPERIMENT_VARIATION.V2 ||
      pdpDeliveryOptions.variant === EXPERIMENT_VARIATION.V4)

  const shouldHideVariantsForRemovePackSizeExperiment =
    useRemovePacksizesExperimentShouldHideVariants()

  return (
    <div
      className={clsx(
        'flex flex-col border-dark-primary-min',
        !hideAddToCart && !pdpDeliveryOptionsEnabled && 'border-b',
        renderGroups.length === 0 && 'pb-2.5',
      )}
    >
      {renderGroups.map((renderGroup, index) => {
        const { contactLensesGroups, group } = renderGroup

        if (group?.shouldRenderGroup) {
          const shouldHideAttributeGroupForExperiment =
            shouldHideVariantsForRemovePackSizeExperiment &&
            isSingleRenderGroup &&
            group.shouldDisplayOnlySelectedValue

          if (shouldHideAttributeGroupForExperiment) {
            return null
          }

          return (
            <Fragment key={group.metaAttributeData.variant_attribute}>
              {index > 0 && !group.shouldDisplayOnlySelectedValue && (
                <ProductPageAttributeGroupDivider />
              )}
              <ProductPageAttributeSelectionGroupRenderer
                attributeGroup={group}
                isSingleGroup={isSingleRenderGroup}
              />
            </Fragment>
          )
        }

        if (contactLensesGroups && contactLensesGroups.length > 0) {
          return (
            <Fragment key="contactLenseGroup">
              <ProductPageAttributeGroupDivider />
              <p className="my-2.5">
                <FormattedMessage id="variantAttributes.contactLens.regionLabel" />
              </p>
              {contactLensesGroups.map((lensesGroup) => {
                if (!lensesGroup.shouldRenderGroup) {
                  return null
                }

                return (
                  <ProductPageAttributeSelectionGroupRenderer
                    attributeGroup={lensesGroup}
                    isSingleGroup={isSingleRenderGroup}
                    key={lensesGroup.metaAttributeData.variant_attribute}
                  />
                )
              })}
            </Fragment>
          )
        }

        return null
      })}
    </div>
  )
}
